;(function($){

    function Schedule_time() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });        

        if($("#modal-schedule-time").length > 0) {
            
            $("#modal-schedule-time").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getUsers();
                    _.getSchedule();

                    var ele = $('select');

                    // gaurav jain: quick fix for select2 not closing on mobile devices
                    ele.on("select2:close", function () {
                        setTimeout(function () {
                            $('.select2-container-active').removeClass('select2-container-active');
                            $(':focus').blur();
                        }, 1);
                    });

                    // gaurav jain: quick fix for select2 not opening on mobile devices if with textbox
                    ele.on('select2:open', function () {
                        $('.select2-search__field').prop('focus', false);
                    });
                    
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    var users = "",
                    schedules = "";

                    if (_.users_id == "") {
                        
                        users = '<div class="row">' +     
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="users_id">Analista</label>' +
                                    '<select name="users_id" id="users_id" disabled></select>' +
                                '</div>'+
                            '</div>'+                           
                       '</div>';

                    }else {
                        users = '<input type="hidden" id="users_id" name="users_id" value="'+_.users_id+'">';
                    }

                    if (_.schedule_id == "") {
                        schedules = '<div class="row">' +     
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="schedule_id">Tarefa</label>' +
                                    '<select name="schedule_id" id="schedule_id" disabled></select>' +
                                '</div>'+
                            '</div>'+                           
                       '</div>'
                    } else {
                        schedules = '<input type="hidden" id="schedule_id" name="schedule_id" value="'+_.schedule_id+'">';
                    } 


                        if((_.userChangeDate == 1))
                        {
                            $(document).ready(function(){
                                $("#start_date").on("input", function(){   
                                    $("#ending_date").val($('#start_date').val());
                                }); 
                            });  
                        }
                    var isDisabledDate = (_.userChangeDate == 1) ? '' : 'readonly="readonly"';
                    var dataBase       = new Date();
                    dataBase           = dataBase.getFullYear()+'-'+(dataBase.getMonth()+1).toString().padStart(2, "0")+'-'+dataBase.getDate().toString().padStart(2, "0");
                    _.html = '<form id="form-schedule-time" enctype="multipart/form-data">'+ users + 
                    schedules + 
                   '<div class="row">' +
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="start_date">Data Inicial</label>' +
                                '<input type="date" id="start_date" name="start_date" value="'+dataBase+'" '+isDisabledDate+'>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-2  col-md-2  col-sm-2 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="start_time">Hora Inicial</label>' +
                                '<input type="time" id="start_time" name="start_time">' +
                            '</div>'+
                        '</div>'+ 
                        '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="ending_date">Data Final</label>' +
                                '<input type="date" id="ending_date" name="ending_date" value="'+dataBase+'" '+isDisabledDate+'>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-2  col-md-2  col-sm-2 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="ending_time">Hora Final</label>' +
                                '<input type="time" id="ending_time" name="ending_time">' +
                            '</div>'+
                        '</div>'+                             
                   '</div>'+
                   '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="text_modal_time">Observações</label>' +
                                '<textarea name="text_modal_time" id="text_modal_time" rows="5"></textarea>' +
                                '<script src="'+$("#app_url").val()+'/vendor/ckeditor/ckeditor.js"></script>'+
                                '<script>'+
                                    'CKEDITOR.replace("text_modal_time", {'+
                                    'toolbar: ['+
                                        '{ name: "document", items: [ "Print"] },'+
                                        '{ name: "clipboard", items: [ "Undo", "Redo" ] },'+
                                        '{ name: "styles", items: [ "Format", "Font", "FontSize" ] },'+
                                        '{ name: "colors", items: [ "TextColor", "BGColor" ] },'+
                                        '{ name: "align", items: [ "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },'+
                                        '"/",'+
                                        '{ name: "basicstyles", items: [ "Bold", "Italic", "Underline", "Strike", "RemoveFormat", "CopyFormatting" ] },'+
                                        '{ name: "links", items: [ "Link", "Unlink" ] },'+
                                        '{ name: "paragraph", items: [ "NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote" ] },'+
                                        '{ name: "insert", items: [ "Image", "Table" ] },'+
                                        '{ name: "tools", items: [ "Maximize" ] },'+
                                        '{ name: "editing", items: [ "Scayt" ] }'+
                                    '],'+
                                    'filebrowserImageUploadUrl :"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'",'+
                                    'uploadUrl:"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'&json",'+
                                    'extraPlugins:"uploadimage",'+
                                    'extraAllowedContent: "h3{clear};h2{line-height};h2 h3{margin-left,margin-top}",'+
                                    'height: 150,'+
                                    'removeDialogTabs: "image:advanced;link:advanced"'+
                                '});'+
                                '</script>' +
                            '</div>'+
                        '</div>'+                             
                   '</div>'+
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +                                                          
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != "") {
                        $('#modal-schedule-time').iziModal('setTitle', '<i class="fa fa-clock-o" aria-hidden="true"></i> Apontamento de Hora Trabalhada');
                        $("#modal-schedule-time .content").html(_.html);

                        _.myForm = $("#form-schedule-time").validate({
                            rules: {
                                users_id: { required: true },
                                schedule_id: { required: true },
                                start_date: { required: true },
                                start_time: { required: true },
                                ending_date: { required: true },
                                ending_time: { required: true },
                                text_modal_time :{ required: true }
                            },
                            messages: {
                                users_id: { required: "Campo Obrigatório" },
                                schedule_id: { required: "Campo Obrigatório" },
                                start_date: { required: "Campo Obrigatório" },
                                start_time: { required: "Campo Obrigatório" },
                                ending_date: { required: "Campo Obrigatório" },
                                ending_time: { required: "Campo Obrigatório" },
                                text_modal_time :{ required: "Campo Obrigatório " }
                            },
                            invalidHandler: function(e) {
                                
                                swal({
                                    title: "Atenção!",
                                    text: "Preencha todos os campos.",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "OK!",
                                    closeOnConfirm: true
                                });

                            },
                            submitHandler: function( form ) {

                                for(instance in CKEDITOR.instances) {
                                    CKEDITOR.instances[instance].updateElement();
                                }

                                $("#form-schedule-time .btn-send").html("Enviando...");
                                
                                $.ajax({
                                    type: "POST",
                                    url: _.API + "apontamentos",
                                    cache: false,
                                    contentType: false,
                                    processData: false,
                                    data: new FormData(form),
                                    success: function(result)
                                    {
                                        $("#form-schedule-time .btn-send").html("Enviar");

                                        form.reset();

                                        $('#modal-schedule-time').iziModal('close'); 

                                        swal({
                                            title: result.message,
                                            text: "Click no botão para fechar!",
                                            type: "success",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: false
                                        }).then(function() {
                                          location.reload();
                                        });                                        
                                    },
                                    error: function(response) {
                                        var errors = $.parseJSON(response.responseText);
                                        
                                        swal({
                                            title: errors,
                                            text: "Click no botão para fechar!",
                                            type: "warning",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: true
                                        });

                                        $myForm.showErrors(errors);
                                        
                                        $("#form-schedule-time .btn-send").html("Enviar");
                                    }
                                });
                            }
                        });
                    }               
                },
                onClosed: function() {
                    _.uri            = null;
                    _.schedule_id    = null;
                    _.users_id       = null;
                    _.userChangeDate = null;
                    _.html           = null;
                    _.myForm         = null;
                    $("#modal-schedule-time .content").html("");
                    $('#modal-schedule-time').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-create-schedule-time").on("click", function(e){
            e.preventDefault();
            _.schedule_id    = $(this).data('schedule');
            _.users_id       = $(this).data('user');
            _.userChangeDate = $(this).data('change-date');
            $('#modal-schedule-time').iziModal('open');           
        });

        $(document).on("change", "select#users_id", function(e){
            e.preventDefault();
            _.users_id  = $(this).val();
            _.getSchedule();
            _.getCustomerSchedule($("#filter_customers_id").val(), $(this).val());
        });

        $("#filter_customers_id").on("change", function(e){
            e.preventDefault();

            if ($(this).val() != "") {
                
               _.getCustomerSchedule($(this).val(), $("#filter_users_id").val());
               _.geContracts($(this).val());

            } else {
                $("#filter_schedule_id").val("").attr('disabled', true).trigger("change");
            }
        });

        if($("#filter_customers_id").val() != "" && $("#filter_customers_id").length > 0) {
            _.getCustomerSchedule($("#filter_customers_id").val(), $("#filter_users_id").val());
            _.geContracts($("#filter_customers_id").val());
        }
    }

    Schedule_time.prototype.getCustomerSchedule = function(customers_id, users_id) {
        var _ =  this;
        var parUserId = "";

        if(users_id != null) {
            parUserId  =  users_id;
        }

        $.get($("#app_url").val() + "/api/cliente/"+customers_id+"/tarefas/"+parUserId, function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               var selectedStatus = ($("select#filter_schedule_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#filter_schedule_id").attr('disabled', false).html(html);
            $("select#filter_schedule_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }

    Schedule_time.prototype.getUsers = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/usuarios", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#users_id").attr('disabled', false).html(html);
            $("select#users_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    };  

    Schedule_time.prototype.getSchedule = function() {

        var _ =  this;

        if(_.users_id != "")
        {        
        
            $.get($("#app_url").val() + "/api/agenda/tarefas/"+_.users_id, function( data ) {
              
                var html = '<option value="">Selecione</option>';

                $.each(data, function(index, value) {
                   html += '<option value="'+ index +'" >'+ value +'</option>';
                });

                $("select#schedule_id").attr('disabled', false).html(html);
                $("select#schedule_id").select2({
                    placeholder: 'Selecione',
                    allowClear: true
                });
            });
        }else {
            $("select#schedule_id").attr('disabled', true).html("");
        }
    };  

    Schedule_time.prototype.geContracts = function(customers_id) {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/contratos/"+customers_id, function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
              var selectedStatus = ($("select#filter_contracts_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#filter_contracts_id").attr('disabled', false).html(html);
            $("select#filter_contracts_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    };   


   	new Schedule_time();

}(jQuery));
 
 
 
 
